<template>
  <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" :width="width" :height="height" version="1.1" style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
       viewBox="0 0 281.89 281.89"
       xmlns:xlink="http://www.w3.org/1999/xlink">
    <g id="Layer_x0020_1">
  <metadata id="CorelCorpID_0Corel-Layer"/>
      <circle class="fil0" cx="140.95" cy="140.95" r="140.95"/>
      <g id="_2190173727792">
   <polygon class="fil1" points="106.7,140.46 186.49,141.38 187.49,140.98 186.92,141.38 187.41,141.38 161.69,196.52 111.96,195.67 104.61,173.85 130.38,163.54 "/>
        <polygon class="fil1" points="105.73,141.38 186.49,140.59 187.49,140.98 186.92,140.59 187.41,140.59 161.69,85.44 111.96,86.29 104.61,108.12 130.24,118.21 "/>
        <polyline class="fil2 str0" points="104.61,108.05 139.53,108.05 140.17,140.69 "/>
        <line class="fil2 str0" x1="104.87" y1="140.52" x2="130.38" y2= "118.35" />
        <line class="fil2 str0" x1="104.61" y1="108.05" x2="187.58" y2= "140.95" />
        <line class="fil2 str0" x1="187.49" y1="140.91" x2="139.53" y2= "108.05" />
        <polyline class="fil2 str0" points="104.61,108.05 111.96,86.22 161.69,85.37 187.6,140.93 "/>
        <line class="fil2 str0" x1="161.69" y1="85.37" x2="139.53" y2= "108.05" />
        <polyline class="fil2 str0" points="104.61,173.85 139.53,173.85 140.17,141.21 "/>
        <line class="fil2 str0" x1="104.87" y1="141.38" x2="130.38" y2= "163.54" />
        <line class="fil2 str0" x1="104.61" y1="173.85" x2="187.58" y2= "140.95" />
        <line class="fil2 str0" x1="187.49" y1="140.98" x2="139.53" y2= "173.85" />
        <polyline class="fil2 str0" points="104.61,173.85 111.96,195.67 161.69,196.52 187.6,140.96 "/>
        <line class="fil2 str0" x1="161.69" y1="196.52" x2="139.53" y2= "173.85" />
        <line class="fil2 str0" x1="105.73" y1="141.38" x2="188.01" y2= "141.38" />
  </g>
 </g>
</svg>
</template>

<script>
  export default {
    props: {
      width: {
        type: [Number, String],
        default: 300
      },
      height: {
        type: [Number, String],
        default: 300
      }
    }
  }
</script>

<style scoped>
  .str0 {stroke:#564A4C;stroke-width:4.52;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:2.61313}
  .fil2 {fill:none}
  .fil1 {fill:#51A8B1}
  .fil0 {fill:#E6E6E6}
</style>